function reset_voted(){
  setTimeout(function(){
    $('.yotpo-regular-box').each(function(){
      if($(this).find('.voted').length >= 1 ){
        var voted =    parseInt($(this).find('.voted').next().text()) + 1;
        $(this).find('.voted').next().text(voted);
      }
    });
  },2000);
}
window.stars = {};

document.addEventListener("LoadedBrowser", function(){
  if(sessionStorage.getItem("cart") == 'true'){
    setTimeout(function(){
     cd = new theme.CartDrawer();
     cd.drawer.open();
     sessionStorage.removeItem('cart');
   }, 500);
  }
})

$(document).ready(function(){
  $('body').delegate('.yotpo-pager .yotpo-page-element','click',function(){
    reset_voted();
    setTimeout(function(){
      var scrollto = $(".customer-review").offset().top - 200;
      $('html, body').scrollTop(scrollto);
    },2000);
  });

  var sticky= $('header').height();
  $('.site-nav__dropdown').css('top',sticky+'px');

  $(window).on('resize', function(){
    var sticky= $('header').height();
    $('.site-nav__dropdown').css('top',sticky+'px');
  })

  //RESIZE SLIDERS' IMAGES
  var pdpMainSliderParent = $('.product-section.product-main-detail');
  var homeProductSectionParent = $('.home-product.change-style');

  function resizeProductImages(target) {
    return;
    var slickSlide = target.find('.product__main-photos .slick-list');
    
    var slickArrowLeft = target.find('.button-slider .button-left');
    var slickArrowRight = target.find('.button-slider .button-right');

    var slickSlideW;

    if (target.hasClass('home-product')) {
      if (slickSlide.width() >= 410) {
        slickSlideW = 410;
      } else {
        slickSlideW = slickSlide.width();
      }
    } else {
      slickSlideW = slickSlide.width();
    }

    //Set top offset for slick arrows
    slickArrowLeft.css('top', slickSlideW / 2);
    slickArrowRight.css('top', slickSlideW / 2);

    if (slickSlideW <= 1000) {
      var neededW = slickSlideW;
      slickSlide.each(function() {
        $(this).find('.photo-zoom-link img').height(neededW);
      });
    } else {
      slickSlide.each(function() {
        $(this).find('.photo-zoom-link img').height(1000);
      });
    }
  }

  $(window).resize(function() {
    //Product Page Main Slider
    resizeProductImages(pdpMainSliderParent);
    //Home Product Slider
    resizeProductImages(homeProductSectionParent);
  });

  setTimeout(function() {
    //Product Page Main Slider
    resizeProductImages(pdpMainSliderParent);
    //Home Product Slider
    resizeProductImages(homeProductSectionParent);
  }, 3000);



  // guarantee active
  $(".guarantee-content").click(function(){
    var iconId = $(this).attr('data-tab');
    $('.guarantee-content').removeClass('active');
    $(".tab-content .description").removeClass('active');

    $(this).addClass('active');
    $("#"+iconId).addClass('active');
  })
  
  $(".duplicate_variant_container .var_option input").click(function(){
    $(this).parents('.duplicate_variant_container').find('.var_option').removeClass('active');
    $(this).parent().addClass('active');
    $(this).closest('.var_option').addClass('active');
    if($(this).hasClass('edited_js')){
      $(this).parent().parent().addClass('active');
    }
  })

  $('.type-collection').click(function(e){
    e.preventDefault();
    var id = $(this).attr('href');
    $('html,body').animate({
      scrollTop: $(id).offset().top - 110
    }, 'fast');
  });


  //get review minicart
  function cart_review(){
    setTimeout(function(){
      $('.ajaxcart__product').each(function(){
        var data = $(this).data('id');
        var vid = data;
        var e =$(this);
        var formData = new FormData();
        formData.append('methods','[{"method":"bottomline","params":{"pid":"'+data+'","link":null,"skip_average_score":true}}]');
        formData.append('app_key',window.yotpo_key);

        $.ajax({
          url: 'https://w2.yotpo.com/batch',
          data: formData,
          processData: false,
          contentType: false,
          dataType: "json",
          type: 'POST',
          success: function(data){
            if (data)
              window.stars[vid] = data[0].result;
            // e.find('.ajax__review .yotpo').empty();
            // e.find('.ajax__review .yotpo').append(data[0].result);
          }
        });
      });
    }, 1000);
  }

  $("body").on("DrawerElementUpdated", function(){
    cart_review();
  });

  $("body").delegate(".js-qty__adjust--plus,.add-to-cart,.collection-btn", "click", function(){
    setTimeout(function(){
      $('.cart__add_item').css('display','flex');
    }, 1000);
  });
  // slider block text
  $(".block-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    loop:true,
    dots:true
  })


  $('.qty-change').click(function () {
    if ($(this).hasClass('qty-plus')) {
      $(this).prev().val(+$(this).prev().val() + 1);
    }
    if($(this).hasClass('qty-minus') && $(this).next().val() > 1){
      $(this).next().val(+$(this).next().val() - 1)
    }
  });
  $(".product-form__variants option").each(function(){

    if ($(this).attr('selected') == 'selected'){
      var a = $(this).attr('data-color')
      $(".Color .name-color")[0].innerHTML = a;
    }
  })

  $('.qty-change').click(function () {
    if ($(this).hasClass('qty-plus')) {
      $(this).prev().val(+$(this).prev().val() + 1);
    }
    if($(this).hasClass('qty-minus') && $(this).next().val() > 1){
      $(this).next().val(+$(this).next().val() - 1)
    }
  });
  $(".product-form__variants option").each(function(){

    if ($(this).attr('selected') == 'selected'){
      var a = $(this).attr('data-color')
      $(".Color .name-color")[0].innerHTML = a;
    }
  })
  //   --
  setTimeout(function(){
    if (window.location.href.indexOf('#write-review') > 0) {
      $('html, body').animate({
        scrollTop: $('.yotpo-main-widget').offset().top - 100
      }, 1500);
    }
  }, 2000);

  
  // write review button
  $(".write-review-custom").click(function(){
    $(".write-review-button").trigger("click");
  });
  $(".product__thumb").hide();
  setTimeout(function(){$(".product__thumb").show();},500);
  //     set time to load
  setTimeout(function(){    
    //   hide arrow when slide < 8
    $('.home-product .grid__image').each(function(){
      var abc = $(this).find('.product__thumbs .slick-track > .slick-slide').length;
      if(abc < 8){
        $(this).find('.button-slider').hide();
      }
    });
    function activeMobileTab(obj){
      $(obj).find("option:selected").each(function(){
        var optionValue = $(this).attr("value");
        if(optionValue){
          $(".tabcontent").not("." + optionValue).hide();
          $("." + optionValue).show();
        } else{
          $(".tabcontent").hide();
        }
      })
    }

    function activeTab(obj)
    {
      $('.faq .tablinks').removeClass('active');
      $(obj).addClass('active');

      var id = $(obj).find('a').attr('href');

      $('.tabcontent').hide();

      $(id) .show();
    }


    activeTab('.faq-section li:first-child');

    $('.faq-section.none-faq li').click(function(){
      activeTab(this);
      return false;
    });

    $(".faq-section.select-mobile").change(function(){
      activeMobileTab(this)
    });

  }, 2000);


  //   ====== Change Grid of article ======
  if ($(".template-blog").length > 0){
    var articleGrid = $(".article-grid--uniform").masonry({
      itemSelector: ".article-grid",
      percentPosition: !0
    });    
  }

  //   ===== End of Change Grid of article =====
  //=== banner container === //


  $(".Color .variant__button-label").click(function(){
    let currentData = $(this).attr('data-variant');
    $(".product__thumbs .product__thumb-item img").each(function(){
      var dataImg = $(this).attr('alt'),
      dataFirst = "first-"+currentData;
      if(dataFirst == dataImg ){

        $(this).parents().eq(2).trigger('click');

      }
    })

    if($(window).width() > 768){
      $(".banner-container img").each(function(){
        var dataImg = $(this).attr('alt'),
        dataBanner = "banner-"+currentData;

        if (dataBanner == dataImg){
          var banner = $(this).attr("src");
          $('.product.detail .desktop').attr("srcset",banner);
        }


      })
    }else{

      $(".product__thumbs .product__thumb-item img").each(function(){
        var dataImg = $(this).attr('alt'),
        dataFirst = "first-"+currentData,
        dataSecond = "second-"+currentData;


        // if (dataFirst == dataImg){
        //   var banner = $(this).attr("data-src");
        //   $('.blocks-1 .product.detail img.mobile').attr("srcset",banner);

        // }else if(dataSecond == dataImg){
        //   var banner = $(this).attr("data-src");
        //   $('.blocks-2 .product.detail img.mobile').attr("srcset",banner);
        //   $('.blocks-2 .product.detail img.mobile').attr("src",banner);
        // }
      })
    }
    //=== end banner container === //
  }) 

  //remove product minicart
  $("body").delegate(".cart__remove", "click", function(){
    $(this).parents('.ajaxcart__row').find('.js-qty__num').val(0).change();
  });

  $("body").delegate(".free_cart_remove", "click", function(){
    $(this).parents('.ajaxcart__row').find('.js-qty__num').val(0).change();
    var remove_id = $(this).parents('.ajaxcart__row').parent().attr('data-id');
    sessionStorage.setItem("nofreeid", true);
  });

  //prevent default view review
  $('.template-product .product-main-detail .review-yotpo').on('click', function(e) {
    e.preventDefault();
    var scrollto = $(".customer-review").offset().top - $(".customer-review .title-review").height() * 2;
    $('html, body').animate({
      scrollTop: scrollto
    });
  });

  //scrolling to content in result pages
  $('#shopify-section-article-template a[href*=\\#]').on('click', function(e){
    e.preventDefault();
    var scrollDistance = $(this.hash).offset().top - 100;
    $('html, body').animate({
      scrollTop : scrollDistance
    }, 500);
  });
  
  setTimeout(function(){
    if ($(".template-product .product-main-detail  .var_option").length >= 3) {
      $('.product-main-detail .var_option:last-child input').trigger('click').trigger('click');
      $('.product-main-detail .var_option:last-child').addClass('active');
    }
    if (meta.product) {
      var variants_pdp = JSON.parse($("#VariantsJson-"+meta.product.id).html())
      auto_tick_variant(variants_pdp);
    }
    coll_auto_tick_variant()
  },50);

  
    // Login to wordpress site
    $('.account').click(function(e){
      e.preventDefault();
      window.location = 'http://beta.bodyboss.com/login/';

    })
    // check IOS or Window
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
      $("body").addClass("mac");
    } else {
      $("body").addClass("window");
    }
    $('.template-product .home-product.change-style .style2').click(function(e){
      e.preventDefault();
      var id = $(this).data("id");
      addItemAPI(id, $(this));
    });
    var popup_close = document.getElementsByClassName('js-close');
    for (var i = 0; i < popup_close.length; i++)
    {
      popup_close[i].onclick  = function ()
      {
        popupClose();
      };
    }

  });

$('body').on('updatedCartDrawer', function(){
  setTimeout(function(){
    form = $("#cartForm");
    btn = $("#cartForm #cartFormButtonSubmit");    
    if (!$(".btn-outside").length) {
      $(btn).addClass("btn-outside");
      $("#CartDrawer").append(btn);
      $("#CartDrawer #cartFormButtonSubmit").click(function(){
        theme.checkPromotionBeforeCheckout();
        // $("#cartFormButtonSubmitInput").click();
      });
    } else {
      $(btn).remove();
    }
  }, 500);
});

$('body').on('drawerOpen.CartDrawer', function(){
  setTimeout(function(){
    form = $("#cartForm");
    btn = $("#cartForm #cartFormButtonSubmit");
    btnCart = $("#cartDrawer > #cartFormButtonSubmit");
    if (!$(btnCart).length) {
      $(btn).addClass("btn-outside");
      $("#CartDrawer").append(btn);
      $("#CartDrawer #cartFormButtonSubmit").click(function(){        
        theme.checkPromotionBeforeCheckout();
        // $("#cartFormButtonSubmitInput").click();
      });
    }
  }, 500);
});

function auto_tick_variant(variants_pdp) {
  var selectedVar = window.auto_ticked_variant;
  variants_pdp.forEach(function(item, i) {
    if (selectedVar.includes(item.id)) {
      console.log('auto tick')
      console.log(item.id)
      $('.product-main-detail .var_option[data-variant-id='+item.id+'] input').trigger('click').trigger('click');
      $('.product-main-detail .var_option[data-variant-id='+item.id+']').addClass('active');
    }
  })
}


function coll_auto_tick_variant() {
  var selectedVar = window.auto_ticked_variant;

  if (selectedVar != '' && selectedVar != undefined) {
    selectedVar = selectedVar.split(',')
    selectedVar.forEach(function(item, i) {
      $('.var_option[data-variant-id='+item+'] input').trigger('click').trigger('click');
      $('.var_option[data-variant-id='+item+']').addClass('active');
    })
  }
}


function slide_home(){
  // fix slider homepage

  $('.mobile-padding-top').each(function(){
    var originalId = $(this).attr('id');
    var originalParentId = $(this).parents('.page-content').find(".js-reset_slider").attr('id');
    var main = "#" + originalId;
    var thumb = "#" + originalParentId;

    var checkCondition = $(this).parents().hasClass('home-product');
    if (checkCondition) {
      $(this).attr('id', originalId + '-home-product');
      $(this).parents('.page-content').find(".js-reset_slider").attr('id', originalParentId + '-home-product')
      main += "-home-product";
      thumb += "-home-product";
    }


    $(main).not('.slick-initialized').slick({
      slidesToScroll: 1,
      focusOnSelect: true,
      adaptiveHeight: false,
      accessibility: false,
      arrow: true,
      dots: false,
      infinite: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4000,
      variableWidth: false,
      asNavFor:thumb

    });
    $(thumb).not('.slick-initialized').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      focusOnSelect: true,
      infinite: true,
      focusOnSelect: true,
      asNavFor:main
    });
  });

if($(window).width() > 768){
  $(".testimonials-product").slick({
    slidesToShow: 4,
      //     centerMode: true,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      loop: true,
      dots:false,
      infinite: true,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0248/0442/5803/files/arrow-left.png?92659'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0248/0442/5803/files/arrow-right.png?92659'>",

      responsive: [
      {
        breakpoint: 1080,
        settings: {
          arrows: true,
          slidesToShow: 3
        }
      }
      ]
    });
  $('#TestimonialsCustom-1559874136638').slick({
    slidesToShow: 4,
      //     centerMode: true,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      loop: true,
      infinite: true,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0248/0442/5803/files/arrow-left.png?92659'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0248/0442/5803/files/arrow-right.png?92659'>",

      responsive: [
      {
        breakpoint: 1080,
        settings: {
          arrows: true,
          slidesToShow: 3
        }
      }
      ]
    });
}
if($(window).width() < 768){
  setTimeout(function(){ 
    var postGrid = $(".testimonials .testimonials-product").masonry({
      itemSelector:".testimonials-product .grid__item",
      percentPosition:true
    })
    var postGridHome = $(".testimonials-slider").masonry({
      itemSelector:".testimonials-slider .aos-init",
      percentPosition:true
    })

  }, 2000);
  var slickConfig = {
    dots: true,
    infinite: true,
    lazyLoad: 'ondemand',
    centerMode: true,
    slidesToShow: 4,
    slidesToScroll: 3,

    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    ]
  }

  if ($('.testimonials-slider').length > 0) {
      $('.testimonials-slider').slick(slickConfig);
  }

  if ($('.best-seller-carousel').length > 0) {
    $('.best-seller-carousel').slick(slickConfig);
    
  }

}
    // slider button 

    $(".button-left").click(function(){
      $(this).parent().prev().children().find(".slick-prev").trigger('click');
    })
    $(".button-right").click(function(){
      $(this).parent().prev().children().find(".slick-next").trigger('click');
    })
  }

  $(document).ready(function(){
    handleChooseEdition();
  });

  function handleChooseEdition(){
      //add cart
      $('.collection-template .js-reset_radio, .template-list-collections  .js-reset_radio').click(function(){
        var id = $(this).data('variantid');
        $(this).parents('.product-single__form').find('.add-option').attr('onclick','addItemAPI('+id+',this)');
      });

      $('.js-reset_radio').click(function(){
        $(this).parents('.duplicate_variant_container').find('.var_option').removeClass('active');
        $(this).parent().addClass('active');
      });

  //choose option 
  $('.js-reset_radio').click(function(){
    $(this).parents('.product-single__form').find('.collection-btn').removeAttr('disabled','disabled');
    $(this).parents('.product-single__form').find('.add-to-cart').removeAttr('disabled','disabled');
  });
}

function edition_home(){
  handleChooseEdition();
  // option product homepage
  $('.choose-option').click(function(){
    $(this).hide();
    $(this).next().show();
    $(this).closest('.product-single__form').find('.duplicate_variant_container').slideToggle();
    $(this).closest('.product-single__form').find('.duplicate_variant_container .var_option.active:last-child input').trigger('click');
  });

  $('.grid-option-homepage .duplicate_variant_container input').click(function(){
    $(this).closest('.duplicate_variant_container').find('.var_option').removeClass('active');
    $(this).parent().addClass('active');
  });

  $('.icon-close-click').click(function(){
    $(this).parent().slideToggle();
    $(this).closest('.product-single__form').find('.add-option').hide();
    $(this).closest('.product-single__form').find('.choose-option').show();
  });

  //   ---
    ///auto open choose
    $('.template-index .choose-option').each(function(){
      $(this).trigger('click');
    });
  //trigger option
  if($('.template-product').length <= 0 ){
    if ($(".duplicate_variant_container .var_option").length >= 3) {
      $(".duplicate_variant_container .var_option:last-child input").trigger('click');
      $(".duplicate_variant_container .var_option:last-child").addClass('active');
    }
  }
  
}

function restarYotpo(){
  $('.sr-only').each(function(){
    var data = $(this).text();
    var start = data.indexOf(' star');
    data = data.slice(0,start);
    $(this).text(data+'/5 Stars');
    var count = $(this).parents('.yotpo').find('.text-m').text();
    var start_count = count.indexOf(' Review');

    if ($(this).parents('.yotpo').find('.reviews__count').length==0){
      if(data != 0){
        count = count.slice(0,start_count);
        $(this).parents('.yotpo').find('.text-m').before('<span class="reviews__count">- '+data+'/5 ('+count+')</span>');
      }else{
        count = count.slice(0);
        $(this).parents('.yotpo').find('.text-m').before('<span class="reviews__count">- '+data+'/5 ('+count+')</span>');
      }
    }
  });
}

function starsTemp(){
  $(".yotpo.bottomLine").each(function(){
    id = $(this).attr('data-product-id');
    if (id) {
      window.stars[id] = $(this).html();
    }
  })
}

document.addEventListener("YotpoLoaded", function(){
  if (Yotpo) {
    Yotpo.ready(function(){
      setTimeout(function(){
        restarYotpo();
        starsTemp();
      },1000);
    });
  }
});
edition_home();
slide_home();
reset_voted();